/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-03-28 12:17:11
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-02 15:40:25
 * @FilePath: \newmall\src\config\color.config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// export const primaryColor = '#9774E1'
// export const secondaryColor = '#F03867'
import vue from 'vue'

const colorConfig = {
  primaryColor: '#9774E1', //   #9774E1 #f36857
  primarylightColor: '#EDE9F7',
  secondaryColor: '#F03867',
  tertiaryColor: '#D7CCF0', // '#D7CCF0',
  cakePrimaryColor: '#F03867',
  pinkColor: '#F03867',
  priceColor: '#DE1C24'
}

const exchangeTheme = {
  primary: '#36D399', // #36D399, #82d9ed, #FF7D00
  primarylight: '#82d9ed',
  secondary: '#82d9ed',
  price: '#82d9ed'
}

// 注册兑换主题色
for (const [key, value] of Object.entries(exchangeTheme)) {
  document.documentElement.style.setProperty(
    `--exchange-${key}`,
    value
  )
}

vue.prototype.$exchangeColor = exchangeTheme

// 注册颜色
vue.prototype.$colorConfig = colorConfig

export default colorConfig
